import { BillingPlanIds } from '../enums/billing-plan-ids';
import { Features } from '../constants/features';

const FreePlanFeatureDisplay = {
  hidden: [Features.BarcodeScanning, Features.PackingSlips, Features.ProductCatalog, Features.InventoryManagementBasic],
};

export const StarterPlanFeatureDisplay = {
  hidden: [],
};

export const PlanDisplayMap = {
  [BillingPlanIds.Free2025Q2]: FreePlanFeatureDisplay,
  [BillingPlanIds.Starter2025Q2]: StarterPlanFeatureDisplay,
};

export const getFeatureDisplayForPlan = (billingPlanId) => {
  return PlanDisplayMap[billingPlanId] || {};
};
